import { CATEGORY_CHOICES } from '@constants/vatReturns';

export const FILE_GROUPS = {
  PROOF_PAYMENT: CATEGORY_CHOICES.PROOF_PAYMENT,
  SUPPORTING_DOCUMENT: CATEGORY_CHOICES.SUPPORTING_DOCUMENT,
  ONLINE_SPREADSHEET: CATEGORY_CHOICES.ONLINE_SPREADSHEET,
  GAME_CHANGER_OUTPUT: CATEGORY_CHOICES.GAME_CHANGER_OUTPUT,
  VAT_RETURN: CATEGORY_CHOICES.VAT_RETURN,
  WORKING_FILES: 'workingFiles',
} as const;
